<template lang="pug">
.dialog-container(id="DialogDelete-container")
  //- seems we need a hack for [enter] button
  button.invisible(v-if='this.$store.state.Medium.media_selected_left.length > 0', style='opacity: .01', ref="submitButton", @keyup.enter="deleteMedia()") {{  'invisible button '}}
  .container(v-if='this.$store.state.Medium.media_selected_left.length > 0')
    h4 {{$t('Media to be deleted')}}:
    hr.header
    ShortMediaList(id="DialogDelete-mediaList" ref='deleteMediaList', :items='this.$store.state.Medium.media_selected_left', :showThumbs="true", :showMediaIcons="true", @selectedItemsChanged='selectedItemsChanged')
  .container.centered
    el-button.confirm(id="DialogDelete-deleteButton" v-if='!saving', type="success", @click="deleteMedia()", circle)
        | &nbsp; {{$t("Delete")}} &nbsp;
        font-awesome-icon.linker-icon(icon="trash")
    el-button.confirm.spinner(v-if='saving', type="primary", disabled, circle)
      font-awesome-icon.spinner-icon.fa-pulse(icon="spinner")
      .spinner-text {{ percentDone }}%
  .container
    hr.header
    MediumInPlaylists(v-if='this.selectedItems.length === 1', id="DialogDelete-affectedList" :medium='this.selectedItems', operation='delete')
    h5.warning(v-else) {{ $t('Please select one item to see which desktops and playlists will be affected') }}
  .container(v-if='this.$store.state.Medium.media_selected_left.length === 0')
    p {{$t('Please select some media on the left to delete them. You will be informed about consequences prior to delete.')}}
</template>

<script>

import Vue from 'vue'
import ShortMediaList from '../Common/ShortMediaList'
import MediumInPlaylists from '../Medium/MediumInPlaylists'

export default {
  props: [],
  components: {
    ShortMediaList,
    MediumInPlaylists
  },
  created () {
    this.selectedItems = JSON.parse(JSON.stringify(this.$store.state.Medium.media_selected_left))
    this.$nextTick(() => {
      this.$refs.submitButton.focus()
    })
  },
  data () {
    return {
      errors: {
      },
      saving: false,
      percentDone: 0,
      selectedItems: []
    }
  },
  methods: {
    selectedItemsChanged (selectedItems) {
      this.selectedItems = selectedItems
    },
    async deleteMedia () {
      this.$emit('linkerJobStarted')
      this.saving = true
      const toBeDoneOperations = this.$refs.deleteMediaList.selectedItems.length
      let doneSoFarOperations = 0
      try {
        for (const mediumToDelete of this.$refs.deleteMediaList.selectedItems) {
          await this.__deleteMedium(mediumToDelete.id)
          doneSoFarOperations++
          this.percentDone = parseInt(doneSoFarOperations / toBeDoneOperations * 100)
        }
      } catch (error) {
        this.$store.dispatch('Medium/clearMediaSelectedLeft')
      } finally {
        this.$store.dispatch('Medium/clearMediaSelectedLeft')
        // If any of deleted media is currently open in right panel, force route without media editor
        if (this.$refs.deleteMediaList.selectedItems.map(m => m.id).includes(parseInt(this.$route.params.mediumEditor.split(',')[1]))) {
          this.$router.push({ path: '/layout-full/' + this.$route.params.leftPanel + '/' + this.$route.params.rightPanel + '/medium,0' })
        }
        Vue.nextTick(() => {
          this.$emit('linkerJobDone', 'delete')
          this.saving = false
          this.percentDone = 0
        })
      }
    },
    async __deleteMedium (mediumId) {
      const path = `medium/destroy`
      await Vue.axios.post(path, { mediumId: mediumId })
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "./dialog.scss";
.confirm {
  height: 100px;
  width: 100px;
  font-size: 12px;
  margin-top: auto auto;
  text-transform: uppercase;
  &.spinner {
    .spinner-icon {
      font-size: 40px;
      margin-top: -10px;
    }
    .spinner-text {
      font-size: 10px;
      margin-top: 9px;
    }
  }
}
.centered {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Linker/DialogDelete.vue